export default __webpack_public_path__ + "static/media/A004hussain.daf40a76.jpg";